import React from "react";

import { EuiDatePicker } from "@equipmentshare/ds2";

import { Time } from "~/Time";
import { State } from "./State";
import moment from "moment";

export type TimePickerProps = {
  readonly revision: State;
  readonly onChange: (time: moment.Moment | null) => void;
};

export const EndTimePicker = ({ revision, onChange }: TimePickerProps) => {
  return (
    <EuiDatePicker
      data-testid="end-time-picker"
      dateFormat="h:mm:ss A"
      timeFormat="h:mm:ss A"
      showTimeSelect
      showTimeSelectOnly
      selected={Time.DateTime.toMoment(revision.endTime)}
      onChange={onChange}
      minDate={Time.DateTime.toMoment(revision.startTime).add(1, "second")}
      maxDate={Time.DateTime.toMoment(revision.endTime)
        .add(1, "days")
        .startOf("day")
        .subtract(1, "second")}
      minTime={Time.DateTime.toMoment(revision.startTime).add(1, "second")}
      maxTime={Time.DateTime.toMoment(revision.endTime)
        .add(1, "days")
        .startOf("day")
        .subtract(1, "second")}
    />
  );
};

export const StartTimePicker = ({ revision, onChange }: TimePickerProps) => {
  return (
    <EuiDatePicker
      dateFormat="h:mm:ss A"
      timeFormat="h:mm:ss A"
      showTimeSelect
      showTimeSelectOnly
      selected={Time.DateTime.toMoment(revision.startTime)}
      onChange={onChange}
      minDate={Time.DateTime.toMoment(revision.startTime).startOf("day")}
      maxDate={Time.DateTime.toMoment(revision.startTime)
        .add(1, "days")
        .startOf("day")
        .subtract(1, "second")}
      minTime={Time.DateTime.toMoment(revision.startTime).startOf("day")}
      maxTime={Time.DateTime.toMoment(revision.startTime)
        .add(1, "days")
        .startOf("day")
        .subtract(1, "second")}
    />
  );
};
